import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CardLoginComponent } from 'src/app/components/card-login/card-login.component';
import { JwtService } from 'src/app/jwt.service';
import { CORE_IMPORTS } from 'src/app/providers/module-providers';


@Component({
  standalone: true,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [CORE_IMPORTS, CardLoginComponent]
})
export class LoginComponent implements OnInit {

  constructor(
		private router: Router,

  ) { }

  ngOnInit () {
		if (JwtService.loggedIn()) {
			this.router.navigate(['/home']);
		}
  }

}
